import {Trans} from '@lingui/macro';
import {isUndefined} from 'lodash';
import React, {FC} from 'react';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {IconName} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {PaletteColorsEnum} from '../../../../../../../libs/shared/ui/src/styles/paletteModel';
import {TeammateModel} from '../../../../../../models/api/teammateModel';
import {DropdownItemAccentIcon} from '../../../../../common/dropdowns/dropdownItemAccentIcon';

/*
 * Props.
 */

interface AssignDropdownUnassignItemProps extends DropdownItemProps {
  assignee?: TeammateModel;
  iconName: IconName;
  color?: PaletteColorsEnum;
  shouldHideBackground?: boolean;
}

/*
 * Component.
 */

export const AssignDropdownUnassignItem: FC<AssignDropdownUnassignItemProps> = (props) => {
  const isChecked = isUndefined(props.assignee);
  return (
    <DropdownItem {...props} isChecked={isChecked}>
      <DropdownItemAccentIcon
        label={null}
        iconName={props.iconName}
        color={props.color}
        shouldHideBackground
      />
      <DropdownItemContent isChecked={isChecked}>
        <Trans id="dropdown-assign-unassigned">Unassigned</Trans>
      </DropdownItemContent>
    </DropdownItem>
  );
};
